export interface AwardExecutiveSummaryFileTemplate {
  executiveSummaryFileTemplateId: number;
  awardId: number;
  fileName: string;
  content: File;
}

export function createAwardExecutiveSummaryFileTemplate(awardId: number, content: File) {
  return {
    executiveSummaryFileTemplateId: 0,
    awardId,
    fileName: content.name,
    content
  }
}

export function copyAwardExecutiveSummaryFileTemplate(fileTemplate: AwardExecutiveSummaryFileTemplate): AwardExecutiveSummaryFileTemplate {
  return {
    executiveSummaryFileTemplateId: fileTemplate.executiveSummaryFileTemplateId,
    awardId: fileTemplate.awardId,
    fileName: fileTemplate.fileName,
    content: fileTemplate.content,
  }
}

export function compareAwardExecutiveSummaryFileTemplate(
  fileTemplateA: AwardExecutiveSummaryFileTemplate,
  fileTemplateB: AwardExecutiveSummaryFileTemplate
): boolean {
  if (!fileTemplateA && !fileTemplateB) return true;
  else if (!fileTemplateA) return false;
  else if (!fileTemplateB) return false;

  return fileTemplateA.executiveSummaryFileTemplateId === fileTemplateB.executiveSummaryFileTemplateId &&
    fileTemplateA.awardId === fileTemplateB.awardId &&
    fileTemplateA.fileName === fileTemplateB.fileName;
}
